import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Label,
  Input,
  CustomInput,
} from 'reactstrap'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import shortid from 'shortid'
import styled from 'styled-components'
import Select from 'react-select'
import CustomButtonDate from './custom-datepicker'
import { customStyles, invalidStyles, leave_time, FONTS, COLORS } from '../../../constants'
import "../../../static/css/index.css"

class CompensateRequestForm extends React.Component {
  render() {
    const newCompensateRequest = get(this.props, 'newCompensateRequest')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ get(this.props, 'showCompensateForm') }
        toggle={ get(this.props, 'handleCloseRequest') }
      >
        <ModalHeader
          toggle={ get(this.props, 'handleCloseRequest') }
        >
          <HeadModal>
          Compensate Work Request
          </HeadModal>
        </ModalHeader>
        <ModalBody>
          <LabelText>
            Project<span style={ { color: 'red' } }>*</span>
          </LabelText>
          <Row noGutters>
            <Col>
              <SelectInputField
                styles={ get(newCompensateRequest, 'project_id.project_id') === undefined ? invalidStyles : customStyles }
                placeholder="Enter project"
                value={ get(newCompensateRequest, 'project_id') }
                options={ orderBy(get(this.props, 'projectList'), 'label', 'asc') }
                onChange={ (e) => this.props.handleInputCompensate('project', e) }
              />
            </Col>
          </Row>
          <LabelText>
            Approver<span style={ { color: 'red' } }>*</span>
          </LabelText>
          <Row noGutters>
            <Col>
              <SelectInputField
                styles={ get(newCompensateRequest, 'approver_id.approver_id') === undefined ? invalidStyles : customStyles }
                options={ get(this.props, 'compensateApprovers') }
                onChange={ (e) => this.props.handleInputCompensate('approver', e) }
                value={ get(newCompensateRequest, 'approver_id') }
              />
            </Col>
          </Row>
          <LabelTextDate>
            Compenste Work Date<span style={ { color: 'red' } }>*</span>
          </LabelTextDate>
          <RowDate>
            <ColStart>
              <LeaveDatePicker
                autoComplete='off'
                onChange={ (e) => this.props.handleInputCompensate('start_date', e) }
                placeholderText='DD/MM/YYYY'
                selected={ get(newCompensateRequest, 'start_date') }
                dateFormat="DD/MM/YYYY"
                showYearDropdown
                showMonthDropdown
              />
            </ColStart>
            {'-'}
            <ColEnd>
              <LeaveDatePicker
                autoComplete='off'
                onChange={ (e) => this.props.handleInputCompensate('end_date', e) }
                placeholderText='DD/MM/YYYY'
                selected={ get(newCompensateRequest, 'end_date') }
                dateFormat="DD/MM/YYYY"
                popperPlacement="bottom-start"
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
              />
            </ColEnd>
          </RowDate>
          { /* date picker for mobile */ }
          <LabelTextMobile>Compenste Work Date<span style={ { color: 'red' } }>*</span></LabelTextMobile>
          <RowDateMobile>
            <LabelDate>Start Date : </LabelDate>
            <ColStartMobile>
              <LeaveDatePicker
                autoComplete='off'
                customInput={ <CustomButtonDate /> }
                onChange={ (e) => this.props.handleInputCompensate('start_date', e) }
                name="start_date_compensate"
                placeholderText='DD/MM/YYYY'
                selected={ get(newCompensateRequest, 'start_date') === '' ? '' : get(newCompensateRequest, 'start_date') }
                dateFormat="DD/MM/YYYY"
                popperPlacement="bottom-start"
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
              />
            </ColStartMobile>
            <LabelDate>End Date : </LabelDate>
            <ColEndMobile>
              <LeaveDatePicker
                autoComplete='off'
                customInput={ <CustomButtonDate /> }
                onChange={ (e) => this.props.handleInputCompensate('end_date', e) }
                name="end_date_compensate"
                placeholderText='DD/MM/YYYY'
                selected={ get(newCompensateRequest, 'end_date') === '' ? '' : get(newCompensateRequest, 'end_date') }
                dateFormat="DD/MM/YYYY"
                showYearDropdown
                showMonthDropdown
              />
            </ColEndMobile>
          </RowDateMobile>
          { /* date picker for mobile */ }
          <LabelText>Compensate Time</LabelText>
          <Row noGutters>
            <Col>
              <CustomInputField
                type="select"
                value={ get(newCompensateRequest, 'compensate_time') }
                onChange={ (e) => this.props.handleInputCompensate('compensate_time', e) }
              >
                {
                  leave_time.map((s) =>
                    <option key={ shortid() } value={ s.value }>{ s.label }</option>)
                }
              </CustomInputField>
            </Col>
          </Row>
          <LabelText>Remarks</LabelText>
          <Row noGutters>
            <Col>
              <InputField
                placeholder="Enter Remark"
                value={ get(newCompensateRequest, 'remark') }
                onChange={ (e) => this.props.handleInputCompensate('remark', e) }
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter style={ { borderTop: 'none' } } >
          <CustomButton
            color="success"
            onClick={ get(this.props, 'validateCompensateRequest') }
          >Submit</CustomButton>
        </ModalFooter>
      </Modal>
    )
  }
}

CompensateRequestForm.propTypes = {
  handleInputCompensate: PropTypes.func.isRequired,
}

export default CompensateRequestForm

const LabelTextDate = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  margin-top: 2%;
  @media (max-width: 575.98px) {
      display: none;
    }
    @media (max-width: 767.98px) {
      display: none;
    }
`
const LabelText = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  margin-top: 2%;
`
const LabelTextMobile = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  margin-top: 2%;
  @media (min-width: 576px) {
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
    margin-top: 2%;
  }
  @media (min-width: 768px) {
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
    margin-top: 2%;
  }
  @media (min-width: 992px) {
    display: none;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const LabelDate = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: 12px ;
  margin-top: 0%;
  margin-bottom: 0% ;
  margin-left: 15px ;
  @media (min-width: 576px) {
    font-family: ${FONTS.GOTHAM_MEDIUM};
    font-size: 12px ;
    margin-top: 2%;
    margin-right: 10px ;
  }
  @media (min-width: 768px) {
    font-family: ${FONTS.GOTHAM_MEDIUM};
    font-size: 12px ;
    margin-top: 2%;
    margin-right: 10px ;
  }
  @media (min-width: 992px) {
    display: none;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  height: 40px;
  width: fit-content;
  padding-top: 0px;
  padding-bottom: 0px;
`
const HeadModal = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  margin: 0px;
  color: ${COLORS.PRIMARY_RED};
  font-size: ${FONTS.TITLE_SIZE};
`
const LeaveDatePicker = styled(DatePicker)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 216px ;
  height : 30px ;
  font-size: ${FONTS.NORMAL_SIZE};
  padding-left: 5%;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === undefined || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
@media (max-width: 575.98px) {
    width: 100%;
  }
`
const ColEnd = styled(Col)`
  padding-left: 2%;
  padding-right: 0%;
  width: 100%;
`
const ColEndMobile = styled(Row)`
  padding-right: 0%;
  padding-left: 10%;
  width: 100%;
`
const RowDate = styled(Row)`
  padding-right: 0%;
  margin-left: 0%;
  margin-right: 0%;
  width: 100%;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const RowDateMobile = styled(Row)`
  @media (min-width: 576px) {
    padding-right: 0%;
    margin-left: 0%;
    margin-right: 0%;
    width: 100%;
  }
  @media (min-width: 768px) {
    padding-right: 0%;
    margin-left: 0%;
    margin-right: 0%;
    width: 100%;
  }
  @media (min-width: 992px) {
    display: none;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const ColStartMobile = styled(Row)`
  padding-right: 0%;
  padding-left: 10%;
  width: 100%;
`
const ColStart = styled(Col)`
  padding-right: 1%;
  padding-left: 0%;
  width: 100%;
`
const SelectInputField = styled(Select)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 100% ;
  height : 100% ;
  font-size: ${FONTS.NORMAL_SIZE};
`
const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 100% ;
  height : 100% ;
  font-size: ${FONTS.NORMAL_SIZE};
`
const InputField = styled(Input)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 100% ;
  height : 100% ;
  font-size: ${FONTS.NORMAL_SIZE};
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/my-leave/form/compensate.js